export enum Route {
  // public routes
  LOGIN = '/login',
  LOGIN_USC = '/signin/urbansportsclub',
  RECOVER_PASSWORD = '/recovery',
  RECOVER_PASSWORD_SUCCESS = '/recovery/success',
  NEW_PASSWORD = `/recovery/new`,
  NEW_PASSWORD_SUCCESS = '/recovery/new/success',
  ONBOARDING_OLD = '/onboarding',
  ONBOARDING = '/hidden-for-now/onboarding',
  ONBOARDING_STUDIO = '/hidden-for-now/onboarding/studio',
  ONBOARDING_DETAILS = '/hidden-for-now/onboarding/details',
  ONBOARDING_VERIFICATION = '/hidden-for-now/onboarding/verification',
  ONBOARDING_POSTLOGIN = '/postlogin/onboarding',
  ACCOUNT_CONFIRMATION = '/account/confirmation',
  POSTLOGIN_ROOT = '/postlogin',

  // private routes
  HOME = '/',
  LOADING = '/loading',
  PROVIDER_ROOT = '/provider',
  PROVIDER_SELECT = '/provider/select',
  PROVIDER_DETAIL = '/provider/:domain',

  USER_SETTINGS = '/provider/:domain/user/settings',
  USER_SETTINGS_CHANGE_PASSWORD = '/provider/:domain/user/settings?section=password',

  CUSTOMERS = '/provider/:domain/customers',
  CUSTOMER_PROFILE = '/provider/:domain/customers/:customerId',
  CUSTOMER_CREATE = '/provider/:domain/customers?create=open',

  EVENTS = '/provider/:domain/events',
  EVENT_DETAILS = '/provider/:domain/event/details/:eventType/:id',
  EVENT_CREATE = '/provider/:domain/event/create',
  EVENT_TYPE_CREATE = '/provider/:domain/event/create/:eventType',
  EVENT_EDIT = '/provider/:domain/event/edit/:eventType/:id',
  EVENTGROUPS = '/provider/:domain/eventgroups',
  EVENTGROUP_EDIT = '/provider/:domain/eventgroup/edit/:eventType/:groupId',

  CUSTOMER_ADD_PRODUCT = '/provider/:domain/events/:id/customer/:customerId/addproduct',
  BOOK_CUSTOMER = '/provider/:domain/events/:id/book',

  PRODUCTS = '/provider/:domain/products',
  PRODUCTS_CREATE = '/provider/:domain/products?create=open',
  PRODUCTS_CREATE_CREDIT_PASS = '/provider/:domain/products?create=credit_pass',
  PRODUCTS_UPDATE_CREDIT_PASS = '/provider/:domain/products?id=:id&create=credit_pass',
  PRODUCTS_CREATE_CONTRACT = '/provider/:domain/products?create=contract',
  PRODUCTS_UPDATE_CONTRACT = '/provider/:domain/products?id=:id&create=contract',
  PRODUCTS_CREATE_EVENT_TICKET = '/provider/:domain/products?create=event_ticket',
  PRODUCTS_UPDATE_EVENT_TICKET = '/provider/:domain/products?id=:id&create=event_ticket',

  IMPORT = '/provider/:domain/import',
  IMPORT_REVIEW = '/provider/:domain/import/review',
  IMPORT_COMPLETE = '/provider/:domain/import/complete',

  PROVIDER_SETTINGS = '/provider/:domain/settings/',
  PROVIDER_LOCATIONS = '/provider/:domain/settings/locations',
  PROVIDER_LOCATIONS_EDIT_BASE = '/provider/:domain/settings/locations/edit',
  PROVIDER_LOCATIONS_EDIT = '/provider/:domain/settings/locations/edit?id=:id',
  PROVIDER_LOCATIONS_CREATE = '/provider/:domain/settings/locations/create',
  PROVIDER_LOCATIONS_COPY = '/provider/:domain/settings/locations/edit?id=:id&copy=true',

  ATTENDANCE = '/provider/:domain/attendance',

  PAYOUTS = '/provider/:domain/payouts',

  PROVIDER_STAFF = '/provider/:domain/staff',
  PROVIDER_STAFF_CREATE = '/provider/:domain/staff/create',
  PROVIDER_STAFF_EDIT = '/provider/:domain/staff/create?id=:id',

  CALENDAR = '/provider/:domain/calendar',

  // organisation routes
  ORGANISATION_ROOT = '/organisation',
  ORGANISATION_SELECT = '/organisation/select',
  ORGANISATION_DETAIL = '/organisation/:domain',
  ORGANISATION_SETTINGS = '/organisation/:domain/settings',
  ORGANISATION_STAFF = '/organisation/:domain/staff',
  ORGANISATION_STAFF_CREATE = '/organisation/:domain/staff/create',
  ORGANISATION_STAFF_UPDATE = '/organisation/:domain/staff/create?id=:id',
  ORGANISATION_STUDIO = '/organisation/:domain/studio',
  ORGANISATION_STUDIO_CREATE = '/organisation/:domain/studio/create',
  ORGANISATION_MERCHANT = '/organisation/:domain/merchants',
  ORGANISATION_MERCHANT_SETTING = '/organisation/:domain/merchants/:merchantId',

  // accept/reject public api page
  ACCEPT_REJECT_PUBLIC_API = '/provider/:domain/publicApi',
  ACCEPT_REJECT_PUBLIC_API_WITH_PARAMS = '/provider/:domain/publicApi?clientId=:clientId&redirectUrl=:redirectUrl',

  // general redirect
  REDIRECT = '/redirect/:url',

  // integrations
  INTEGRATIONS = '/provider/:domain/integrations',
  URBANSPORTSINTEGRATION = '/provider/:domain/integrations/usc',
  THIRDPARTYINTEGRATION = '/provider/:domain/integrations/:integration',
  THIRDPARTYINTEGRATIONCREATE = '/provider/:domain/integrations/:integration/:id',

  // video on demand
  VIDEO_ON_DEMAND_ACTIVATE = '/provider/:domain/activate-vod',
  VIDEO_ON_DEMAND = '/provider/:domain/vod',
  VIDEO_ON_DEMAND_CREATE = '/provider/:domain/vod/create',
  VIDEO_ON_DEMAND_EDIT = '/provider/:domain/vod/create/:id',
  //export
  EXPORT_PAGE = '/provider/:domain/export',
  BASE_EXPORT_ROUTE = '/export',
}

export const PRIVATE_ROUTES_WITHOUT_SIDEBAR: string[] = [Route.PROVIDER_SELECT];

export const SKIPPED_ROUTES: string[] = [
  Route.EVENT_CREATE,
  Route.EVENT_TYPE_CREATE,
  Route.EVENT_EDIT,
];
